import type { ServerResponse } from 'http';

export const appendSetCookie = (res: ServerResponse, cookie: string): void => {
  const existing = res.getHeader('Set-Cookie');
  const header = Array.isArray(existing) ? [...existing] : existing ? [String(existing)] : [];

  header.push(cookie);
  res.setHeader('Set-Cookie', header);
};
